import { DARK_BROWN } from "styles/oneOffColor";

const styles = {
  page: {
    width: "100%",
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 4 },
  },
  // Centered, readable column for form-style steps (Details / Templates / Review).
  formColumn: {
    width: "100%",
    maxWidth: 920,
    mx: "auto",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    mb: 3,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: "10px",
    border: "1px solid rgba(1,67,57,0.15)",
    color: "rgba(1,67,57,0.6)",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "rgba(1,67,57,0.05)",
      color: "primary.main",
    },
  },
  title: {
    fontWeight: 700,
    fontSize: { xs: 18, md: 22 },
    color: "primary.main",
    lineHeight: 1.2,
  },
  stepper: {
    mb: 4,
    maxWidth: 760,
    mx: "auto",
    "& .MuiStepLabel-label": {
      fontSize: 13,
      fontWeight: 600,
      color: "rgba(1,67,57,0.4)",
      "&.Mui-active": { color: "primary.main" },
      "&.Mui-completed": { color: "primary.main" },
    },
    "& .MuiStepIcon-root": {
      color: "rgba(1,67,57,0.15)",
      "&.Mui-active": { color: "primary.main" },
      "&.Mui-completed": { color: "primary.main" },
    },
  },
  stepContent: {
    width: "100%",
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1.5,
    mt: 4,
    pt: 3,
    borderTop: "1px solid rgba(1,67,57,0.1)",
  },
  card: {
    width: "100%",
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: 16,
    color: "primary.main",
  },
  creditChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    flexShrink: 0,
    whiteSpace: "nowrap",
    backgroundColor: "#FBF6E6",
    border: "1px solid #E7D9A6",
    color: DARK_BROWN,
    fontWeight: 600,
    fontSize: 13,
    px: 1.5,
    py: 0.75,
    borderRadius: "999px",
    "& i": { color: "#C99A2E", fontSize: 14 },
  },
  dialogPaper: {
    width: "100%",
    maxWidth: 1100,
    height: { xs: "100%", md: "90vh" },
    maxHeight: { xs: "100%", md: "90vh" },
    borderRadius: { xs: 0, md: 3 },
    overflowY: "auto",
    position: "relative",
  },
  dialogClose: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 1,
    color: "rgba(1,67,57,0.6)",
    "&:hover": { color: "primary.main" },
  },
};

export default styles;
